<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="editEvDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Variable</div
  >

  <form
    class="flex w-[700px] flex-col"
    [formGroup]="editEvForm"
    (ngSubmit)="edit()"
  >
    <div class="mt-9 w-[700px] pr-5 text-base">{{ dataItem.ev.evId }}</div>

    <input
      autocomplete="off"
      spellcheck="false"
      data-cy="editEvDialogValInput"
      class="form-input border-s3 focus:border-m600 mt-6 rounded"
      [ngClass]="{
        'border-r600':
          editEvForm.controls['val'].invalid &&
          editEvForm.controls['val'].touched
      }"
      formControlName="val"
      placeholder="Value"
    />
    <m-validation [control]="editEvForm.controls['val']"></m-validation>

    <div class="mt-6">
      <button
        data-cy="editEvDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editEvDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
